var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorLiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Featured icon/xl/Error/Light circle outline"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#FEE4E2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    stroke: "#FEF3F2",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "alert-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M33.0007 28.332V32.9987M33.0007 37.6654H33.0123M44.6673 32.9987C44.6673 39.442 39.444 44.6654 33.0007 44.6654C26.5573 44.6654 21.334 39.442 21.334 32.9987C21.334 26.5554 26.5573 21.332 33.0007 21.332C39.444 21.332 44.6673 26.5554 44.6673 32.9987Z",
    stroke: "#D92D20",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorLiveIcon);
export default __webpack_public_path__ + "static/media/error-live-icon.5d1121d41232c653f35abe9012611b14.svg";
export { ForwardRef as ReactComponent };